/* eslint-disable camelcase */
import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './Plan.scss';

const Plan = ({ title, className, licensingPlan, planButtons, nrOfEngines }) => {
    const [t, ready] = useTranslation();
    const planClasses = classNames({}, className);
    const spanClasses = classNames({}, 'belowInfo');
    const buttonClasses = classNames({}, 'button text-center');
    const [callToAction, setCallToAction] = useState();

    useEffect(() => setCallToAction(className === 'details' ? (
        <p className={spanClasses}>
            <span
                dangerouslySetInnerHTML={{
                    __html:
                        '* ' +
                        t(
                            'applies to file uploads and bulk requests. <a href=`https://onlinehelp.opswat.com/mdcloud/4._Throttling.html` rel="noopener noreferrer" target="_blank">See documentation</a>'
                        )
                }}
            ></span>
            <span> {t('** When the rate limit is exceeded, how much can the user go above before the API starts blocking requests. The exceeding requests will be processed with lower priority')} </span>

        </p>
    ) : (
        <div className={buttonClasses}>
            {planButtons[className]}
        </div>
    )), [className, planButtons, t]);

    const domLicensingPlans = useMemo(() => {
        return licensingPlan.map((plan, index) => {
            if (plan.indexOf('</a>') > -1) {
                return <li key={index} dangerouslySetInnerHTML={{ __html: plan }}/>;
            }

            if (plan === 'freeEngines') {
                plan = nrOfEngines?.free_engines_count || '-';
            }

            if (plan === 'commercialEngines' || plan === 'enterpriseEngines') {
                plan = nrOfEngines?.commercial_engines_count || '-';
            }

            return <li key={index}>{plan}</li>;
        });
    }, [licensingPlan]);


    if (!ready) {
        return null;
    }

    return (
        <div className={planClasses}>
            <div className="planHeader">
                <h5>{t(title)}</h5>
            </div>
            <div className="planBody">
                <ul className="licensingPlan">{domLicensingPlans}</ul>
                {callToAction}
            </div>
        </div>
    );
};

Plan.propTypes = {
    title: PropTypes.string,
    licensingPlan: PropTypes.array,
    className: PropTypes.string,
    planButtons: PropTypes.object,
    nrOfEngines: PropTypes.object
};

Plan.defaultProps = {
    title: '',
    licensingPlan: [],
    className: '',
    planButtons: {
        'free': <a href='/'>{'Start using now'}</a>,
        'commercial': <a href='/store'>{'Buy now'}</a>,
        'enterprise': <a href={'https://www.opswat.com/contact'} rel="noopener noreferrer" target="_blank">{'Request a quote'}</a>
    }
};

export default Plan;
